import React from "react";
import './ManualesCard.scss'
import addIcon from '../../../assets/icons/icono_agregar-mas_2.png'

const ManualesCardAgregar = ({onClick})=>
{
    return(
        <div className="ManualesCardAgregar">
            <div className="tituloAdd">AGREGAR NUEVO MANUAL</div>
            <div className="image-container">
                <img src={addIcon} alt="" onClick={onClick}></img>
            </div>
        </div>
    )
}
export default ManualesCardAgregar